import {defineStore} from 'pinia';
import redirect_error_page from "@/util/redirect_error_page"
import { useVersionStore } from './version_store';
import ApiRequestWrapper from '@/util/api-request-wrapper';


export const useLearningStatusDetailStore = defineStore('learningStatusDetailStore', {
    // actions
    actions: {
        async fetchDaysRange(payload: any) {
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/days_range', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.days_range
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchDetailTotalSummary(payload: any) {
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/total_summary', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.total_summary
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchDetailByWeek(payload: any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/detail_by_week', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.detail_by_week
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchDetailByMonth(payload: any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/detail_by_month', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.detail_by_month
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchDetailByYear(payload: any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/detail_by_year', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.detail_by_year
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchClassroomAverageByWeek(payload: any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/classroom_average_by_week', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.classroom_average_by_week
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchClassroomAverageByMonth(payload: any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/classroom_average_by_month', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.classroom_average_by_month
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchClassroomAverageByYear(payload: any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/classroom_average_by_year', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.classroom_average_by_year
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchLearningProgress(payload: any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/learning_progress', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.learning_progress
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchClassroomAverageLearningProgress(payload: any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/classroom_average_learning_progress', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.classroom_average_learning_progress
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchCorrectAnswerRate(payload:any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/correct_answer_rate', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.correct_answer_rate
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchClassroomAverageCorrectAnswerRate(payload:any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/classroom_average_correct_answer_rate', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.classroom_average_correct_answer_rate
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchCorrectAnswerRateBySkill(payload:any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/correct_answer_rate_by_skill', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.correct_answer_rate_by_skill.skills_with_correct_answer_rate
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
        async fetchClassroomAverageCorrectAnswerRateBySkill(payload:any){
            const versionStore = useVersionStore()
            try {
                const result = await ApiRequestWrapper.request('post', '/student/api/learning_status_detail/classroom_average_correct_answer_rate_by_skill', payload)
                versionStore.saveAppVersion(result.headers["x-app-version"])
                return result.data.classroom_average_correct_answer_rate_by_skill.skills_with_classroom_average_correct_answer_rate
            }
            catch (e) {
                redirect_error_page(e)
            }
        },
    }
})